import React, { useState, useEffect } from 'react'
import logo from "../../Assets/Images/logo.png"
import { Link } from 'react-router-dom';
import "./Header.scss"
const Header = () => {

    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            setIsSticky(window.scrollY > 0);
        };

        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    const [menuOpen, setMenuOpen] = useState(false);

    const toggleMenu = () => {
        setMenuOpen(prev => !prev);
    };

    return (
        <div>
            <header className={`"header ${isSticky ? "sticky" : "header"}`}>


                <a href="/" className='logo'>
                    <img src={logo} alt="logo" className="img-fluid" />
                </a>

                <nav className='links'>

                    <Link className="quote-btn" to={"/"}>home</Link>

                    <Link className="quote-btn" to={"/about"}>about us</Link>

                    <Link className="quote-btn" to={"/product-range"}>
                        Product Range
                    </Link>

                    {/* <Link className="quote-btn" to={"/blog"}>
                        News &amp; Updates/Blog
                    </Link> */}

                    <Link className="quote-btn" to={"/contact"}>
                        Contact Us
                    </Link>

                </nav>

                <div className="menu-toggle" onClick={toggleMenu}>
                    <p>Menu</p>
                    <svg id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m16.197 118.877c-9.994-9.993-16.197-23.787-16.197-38.967s6.203-28.974 16.197-38.967 23.787-16.197 38.967-16.197h401.672c15.18 0 28.974 6.203 38.967 16.197s16.197 23.787 16.197 38.967-6.203 28.974-16.197 38.967c-9.993 9.994-23.787 16.197-38.967 16.197h-401.672c-15.18 0-28.974-6.203-38.967-16.197zm440.639 258.049h-401.672c-15.18 0-28.974 6.203-38.967 16.197-9.994 9.992-16.197 23.786-16.197 38.966s6.203 28.974 16.197 38.967c9.993 9.994 23.787 16.197 38.967 16.197h401.672c15.18 0 28.974-6.203 38.967-16.197 9.994-9.993 16.197-23.786 16.197-38.967 0-15.18-6.203-28.974-16.197-38.967-9.993-9.993-23.787-16.196-38.967-16.196zm0-176.09h-401.672c-15.18 0-28.974 6.203-38.967 16.197-9.994 9.993-16.197 23.786-16.197 38.967 0 15.18 6.203 28.974 16.197 38.968 9.994 9.993 23.787 16.197 38.967 16.197h401.672c15.18 0 28.974-6.203 38.967-16.197 9.994-9.995 16.197-23.788 16.197-38.968s-6.203-28.974-16.197-38.967c-9.993-9.994-23.787-16.197-38.967-16.197z" /></svg>
                </div>

                <div className="mobile-menu" style={{ display: menuOpen ? "block" : "none" }}>

                    <svg onClick={toggleMenu} id="Layer_1" enable-background="new 0 0 512 512" height="512" viewBox="0 0 512 512" width="512" xmlns="http://www.w3.org/2000/svg"><g id="Layer_2_00000065059526256240422560000002300005481942928013_"><g id="cross"><path d="m359.8 256 140.3-140.3c15.9-15.9 15.9-41.7 0-57.6l-46.1-46.1c-16-16-41.8-16-57.7-.1l-140.3 140.3-140.3-140.3c-15.9-15.9-41.7-15.9-57.6 0l-46.2 46.2c-15.9 15.9-15.9 41.7 0 57.6l140.3 140.3-140.3 140.3c-15.9 15.9-15.9 41.7 0 57.6l46.1 46.1c15.9 15.9 41.7 15.9 57.6 0l140.4-140.2 140.3 140.3c15.9 15.9 41.7 15.9 57.6 0l46.1-46.1c15.9-15.9 15.9-41.7 0-57.6z" /></g></g></svg>
                    <nav>

                        <Link onClick={toggleMenu} className="quote-btn" to={"/"}>home</Link>

                        <Link onClick={toggleMenu} className="quote-btn" to={"/about"}>about us</Link>

                        <Link onClick={toggleMenu} className="quote-btn" to={"/product-range"}>
                            Product Range
                        </Link>

                        {/* <Link className="quote-btn" to={"/blog"}>
                        News &amp; Updates/Blog
                    </Link> */}

                        <Link onClick={toggleMenu} className="quote-btn" to={"/contact"}>
                            Contact Us
                        </Link>

                    </nav>
                </div>

            </header>
        </div>
    )
}

export default Header